<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Manpower"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        工时制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 产假 -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title" id="calsIdActive-box">产假</h4>
                    <span class="actve" id="firstIdactive">1. 签订劳动合同并符合国家计划生育规定的女员工产假为98天，生育奖励假30天。其中产前休假15天。剖腹产增加产假15天。多胞胎生育的，每多生育一个，增加产假15天。</span>
                    <span class="actve" id="firstIdactive">2. 签订劳动合同的男员工在其配偶生育时，可享受7个连续自然日的护理假期。</span>
                    <span class="actve" id="firstIdactive">3. 女员工怀孕流产的，怀孕在4个月以下（含）的休息15天，4个月（不含）以上的可休息42天。</span>
                    <span class="actve" id="firstIdactive">4. 产检假：怀孕1-7个月，每个月可享受1天假期；怀孕第8个月，可享受2天假期；怀孕9个月以上，每个月可享受4天假期，但其中2天已包括在预产假中。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title" id="calsIdActive-box">产假</h4>
                    <span class="actve" id="firstIdactive">5. 有不满一周岁婴儿的女员工，在其正常工作时间内给予每天1小时的哺乳时间。可自选是晚来1小时或早走1小时且固定。</span>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {

        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
        fn() {

        }
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical", // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
  width: 100%;
  height: 100%;
}
.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    display: block;
    margin: 10px auto;
}

.contentImg {
    width: 100%;
    display: block;
    margin-top: 15px;
}
#calsIdActive-box {
    margin-bottom: 20px;
    font-size: 16px
}
.actve {
    line-height: 30px;
    letter-spacing: 1px;
}
#firstIdactive {
    text-indent: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Manpower/manpowerParticulars4.vue